import React from 'react';
import { Navigate } from 'react-router-dom';
import { useStudentPortal } from '../store/StudentPortalContext';
import { useFeaturePacks } from '../store/FeaturePackContext';
import PackDisabledPanel from '../components/PackDisabledPanel';

export default function StudentPortalRoute({ children }) {
  const { student, ready } = useStudentPortal();
  const { packs } = useFeaturePacks();
  if (!ready) {
    return (
      <div className="min-h-screen flex items-center justify-center p-6">
        <div className="sp-panel sp-panel--muted p-4 text-sm">Loading student portal…</div>
      </div>
    );
  }
  if (!student) {
    return <Navigate to="/student-portal/login" replace />;
  }
  if (packs?.student_portal === false) {
    return (
      <PackDisabledPanel
        packName="Student Portal"
        message="Student Portal access is currently disabled for your organisation."
        allowAdminLink={false}
      />
    );
  }
  return children;
}
